/**  Person not eligible e.g. lessons not completed */
const PERSON_TRANSPORT_PERM_NOT_ELIGIBLE = "PERSON_TRANSPORT_PERM_NOT_ELIGIBLE";
/** Person eligible but instructor has not recomended */
const PERSON_TRANSPORT_PERM_ELIGIBLE = "PERSON_TRANSPORT_PERM_ELIGIBLE";
/** instructor has recomended (request will be / has been sent to KULTI) */
const PERSON_TRANSPORT_PERM_RECOMENDED = "PERSON_TRANSPORT_PERM_RECOMENDED";
/** permission approved received from KULTI */
const PERSON_TRANSPORT_PERM_APPROVED = "PERSON_TRANSPORT_PERM_APPROVED";

export const PERSON_TRANSPORT_PERM_STATES = Object.freeze({
  PERSON_TRANSPORT_PERM_NOT_ELIGIBLE,
  PERSON_TRANSPORT_PERM_ELIGIBLE,
  PERSON_TRANSPORT_PERM_RECOMENDED,
  PERSON_TRANSPORT_PERM_APPROVED
});

export const getPersonTransportPermState = (personTransportPermEligible, personTransportPermRecomended, personTransportPermApproved) => {
  if (personTransportPermApproved) {
    return PERSON_TRANSPORT_PERM_APPROVED;
  } else if (personTransportPermRecomended) {
    return PERSON_TRANSPORT_PERM_RECOMENDED;
  } else if (personTransportPermEligible) {
    return PERSON_TRANSPORT_PERM_ELIGIBLE;
  }
  return PERSON_TRANSPORT_PERM_NOT_ELIGIBLE;
}



// WEBPACK FOOTER //
// ./src/components/applicant/getPersonTransportPermState.js